/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { TubChatHistory } from '../models/tub-chat-history';
@Injectable({
  providedIn: 'root',
})
class ChatToolsService extends __BaseService {
  static readonly ChatAdminGetAllChatsPath = '/admin/chat/{patientEmail}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Return a users entire chat history.
   * @param patientEmail
   * @return Ok
   */
  ChatAdminGetAllChatsResponse(patientEmail: string): __Observable<__StrictHttpResponse<TubChatHistory>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/admin/chat/${encodeURIComponent(String(patientEmail))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TubChatHistory>;
      })
    );
  }
  /**
   * Return a users entire chat history.
   * @param patientEmail
   * @return Ok
   */
  ChatAdminGetAllChats(patientEmail: string): __Observable<TubChatHistory> {
    return this.ChatAdminGetAllChatsResponse(patientEmail).pipe(
      __map(_r => _r.body as TubChatHistory)
    );
  }
}

module ChatToolsService {
}

export { ChatToolsService }
